module.exports = __webpack_public_path__ + "img/logo_ena.39fc67af.svg";